<template>
  <div class="workInfo">
    <div
      v-for="(item, idx) in form"
      :key="idx"
      :class="[{ 'has-padding': ['img-link'].includes(item.type) }]"
    >
      <component
        :is="getCom(item)"
        :form-item="item || {}"
        :idx="idx"
        :choosed-key="choosedKey"
        :choosed-info="choosedInfo"
        :omega-item="omegaItem"
        @choose="chooseWork"
      ></component>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { post } from "../tools/request";
import { getEnd, computeJumpTime, computeStayTime } from "../tools/utils";
import { showDialog, showAlertDialog, showLoadingToast } from "../tools/Tip";
import { SERVICE_PHONE, SUPPORT_COUNTRY, ends } from "../tools/constant";
import HomeBanner from "../components/loginComp/home-banner.vue";
import LevelRadioCard from "../components/work/levelRadioCard.vue";
import RadioCard from "../components/work/radioCard.vue";
import NextBtn from "../components/work/nextBtn.vue";

const OTHER_CITY_ID = 12345678;

export default {
  name: "workInfo",
  mounted() {
    try {
      Omega.trackEvent("ibt_gd_selection_people_num_sw", "", {
        ...this.omegaItem,
        // time: new Date().getTime()
      });
    } catch (error) {}
    //解决非正常流程进入--页面刷新，多次请求的bug，旧的i8n作用域已不存在，js有抛错，中断执行，，所以不会触发fn，很hack的做法
    this.timeId = setTimeout(this.getPageConfig, 0);
    try {
      computeJumpTime(this)
    } catch (error) {}
  },
  data() {
    return {
      form: [],
      choosedKey: "",
      choosedInfo: {},
    };
  },
  computed: {
    ...mapState([
      "_ticket",
      "_area",
      "_identity",
      "_product",
      "_uuid",
      "_mx_type_product_text",
      "_ru_se_driver_switch_test",
      "_page_stay_time",
      "_page_jump_time",
      "_route_path"
    ]),
    params() {
      return new URLSearchParams(location.search);
    },
    isPreviewPage() {
      return this.params.get('ob_page_type') === 'preview';
    },
    location_country() {
      return this.params.get("location_country");
    },
    omegaItem() {
      return {
        channel:this.params.get("channel") || "",
        end: getEnd(),
        oid: this.params.get("oid") || Omega.getOmgid(),
        location_country_code: this.location_country,
        driver_id: this.params.get("uid") || this._uuid + '',
      };
    },
  },
  methods: {
    ...mapMutations(["setState"]),
    showSite() {
      this.$refs.offlineSite.getLineSite();
      this.$refs.offlineSite.show();
    },
    handleClick(tag, payload) {
      switch (tag) {
        case "city":
          this.$router.push({ name: "city" });
          break;
        case "identity":
          this.identity = payload;
          this.setState({
            _identity: this.identity,
          });
          try {
            Omega.trackEvent("gd_driverRole_btn_ck", "", {
              driver_role: this.identity,
            });
          } catch (e) {}
          break;
        case "submit":
          showDialog(this, {
            type: "confirm",
            content: this.$t("typeInfo.submit_tips").replace(
              /{role}/,
              this.identityInfo[this.identity].title
            ),
            icon: "cubeic-alert",
            confirmBtn: {
              text: this.$t("typeInfo.OK"),
            },
            cancelBtn: { text: this.$t("typeInfo.Back") },
            onConfirm: this.handleSubmit,
          });
        default:
          break;
      }
    },
    handleSubmit() {
      // 不提交信息,暂存在store中，在baseInfo页面中一起提交
      if (!this.isCanSubmit) return;
      try {
        Omega.trackEvent("gd_driverRoleSubmit_btn_ck", "", {
          driver_role: this.identity,
          ibt_crm_uid: this._uuid,
        });
        gtm({
          event: "s5ObIdSelection",
          Identity: this._identity,
          error: "false",
        });
      } catch (e) {}

      this.$router.replace({
        name: `baseInfo${SUPPORT_COUNTRY[this.location_country] || "Mx"}`,
      });
    },
    getCom(item) {
      return {
        "rotation-banner": HomeBanner,
        work_option: RadioCard,
        other_banner: LevelRadioCard,
        button: NextBtn,
      }[item.type];
    },
    getPageConfig() {
      showLoadingToast(this, this.$t("加载中"));
      let up = new URLSearchParams(window.location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      if (this.isPreviewPage) {
        up.set("page", 'jobs_page_conf');
      }
      let WORK_INFO_PAGE = this.isPreviewPage ? process.env.PHOTOINFO_URL_PRE : process.env.WORK_INFO_PAGE
      post(WORK_INFO_PAGE, up)
        .then((data) => {
          let formData = [];
          let other_option = [];
          data.forEach((item, idx) => {
            if (item.default_select && item.type === "work_option") {
              this.choosedKey = item.key;
              this.choosedInfo = item;
              this.setState({
                _identity: item.identify_type,
                _product: item.product_type,
              });
            }
            if (item.type === "work_option" && !item.required) {
              other_option.push(item);
            } else {
              formData.push(item);
            }
          });
          formData.forEach((item) => {
            if (item.type === "other_banner") {
              item.options = other_option;
            }
          });
          console.log(formData);
          this.form = formData || [];
        })
        .catch((err) => {
          showAlertDialog(this);
        })
        .finally(() => {
          this.toast.hide();
        });
    },
    chooseWork(item) {
      this.setState({
        _identity: item.identify_type,
        _product: item.product_type,
      });
      this.choosedKey = item.key;
      this.choosedInfo = item;
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeId);
    try {
      computeStayTime(this)
    } catch (error) {}
  },
  components: {
    HomeBanner,
    RadioCard,
    LevelRadioCard,
  },
};
</script>
<style lang="scss" scoped>
.workInfo {
  box-sizing: border-box;
  padding-bottom: 2rem;
  min-height: 100%;
  background: #fff;
}
</style>
